import { Box, ButtonBase } from "@material-ui/core"
import ImageIcon from "@material-ui/icons/Image"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"
import type { ReactElement } from "react"

import { AttachmentType } from "../../../models"
import { Header6, NoteAttachmentIcon } from "../../atoms"

import "./attachment-type-selector.styles.scss"
import { useTranslation } from "react-i18next"

export interface IAttachmentTypeSelectorOwnProps {
  attachmentType?: AttachmentType | null
  disabled: boolean
  onSelect: (attachmentType: AttachmentType) => void
}

export function AttachmentTypeSelector(props: IAttachmentTypeSelectorOwnProps): ReactElement {
  const { attachmentType, disabled, onSelect } = props
  const { t } = useTranslation("map")

  function isSelected(type: AttachmentType): boolean {
    return attachmentType === type
  }

  return (
    <Box className="attachment-type-selector">
      <Box className="attachment-type-options">
        <ButtonBase
          className={`attachment-type-option ${isSelected(AttachmentType.Image) ? "selected" : ""}`}
          onClick={() => onSelect(AttachmentType.Image)}
          disabled={disabled && !isSelected(AttachmentType.Image)}
        >
          <ImageIcon fontSize="large" />
          <Header6>{t("attachments.image.imageTitle")}</Header6>
        </ButtonBase>
        <ButtonBase
          className={`attachment-type-option ${isSelected(AttachmentType.Video) ? "selected" : ""}`}
          onClick={() => onSelect(AttachmentType.Video)}
          disabled={disabled && !isSelected(AttachmentType.Video)}
        >
          <PlayCircleFilledIcon fontSize="large" />
          <Header6>{t("attachments.video.videoTitle")}</Header6>
        </ButtonBase>
        <ButtonBase
          className={`attachment-type-option ${isSelected(AttachmentType.Note) ? "selected" : ""}`}
          onClick={() => onSelect(AttachmentType.Note)}
          disabled={disabled && !isSelected(AttachmentType.Note)}
        >
          <NoteAttachmentIcon fontSize="small" noPadding noBackground />
          <Header6>{t("attachments.note.noteTitle")}</Header6>
        </ButtonBase>
      </Box>
    </Box>
  )
}
